import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../components/common/general/CustomText/CustomText";
import { colors, spacing } from "../../../../styles/design-system";

type InsightsMetricCardProps = {
  label: string;
  value: string;
};

const InsightsMetricCard: React.FC<InsightsMetricCardProps> = ({ label, value }) => {
  return (
    <View style={styles.container}>
      <CustomText text={label} size="xs" useTranslationText={false} style={styles.label} />
      <CustomText text={value} size="s" weight="bold" useTranslationText={false} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 10,
    backgroundColor: colors.white,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    gap: 2,
    flex: 1,
    minWidth: 160,
  },
  label: {
    color: colors.grey[500],
  },
});

export default InsightsMetricCard;
